import React from 'react';
import TailspinHeader from './TailspinHeader';

export default function TailspinLayout({ children }) {
  return (
    <div className="min-h-screen" style={{ backgroundColor: '#F8F7F4' }}>
      <TailspinHeader />
      <main>
        {children}
      </main>
    </div>
  );
}

